import axios from 'axios';

type TextToSpeechParams = {
  teamId: string;
  text: string;
};

export const textToSpeech = (params: TextToSpeechParams) => {
  const { teamId, text } = params;
  return axios.post('/api/speech/preview', { text, team_id: teamId });
};
